/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/241-evil2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M16 1c0-.711-.149-1.387-.416-2a5.016 5.016 0 01-2.726 2.643C11.511.612 9.828 0 8.001 0s-3.51.613-4.857 1.643A5.013 5.013 0 01.418-1a4.979 4.979 0 00-.416 2c0 1.15.388 2.208 1.04 3.053a8 8 0 1013.92 0A4.979 4.979 0 0016.002 1zM9.001 5.946c.032-.741.706-1.234 1.275-1.518.543-.271 1.08-.407 1.102-.413a.5.5 0 11.242.97c-.275.07-.602.189-.89.334A.998.998 0 019.998 7a1 1 0 01-1-1L9 5.946zM4.015 4.379a.5.5 0 01.606-.364c.023.006.559.141 1.102.413.568.284 1.243.776 1.275 1.518L7 6a1 1 0 11-1.732-.681 4.638 4.638 0 00-.89-.334.5.5 0 01-.364-.606zM8 13a4.999 4.999 0 01-4.288-2.427l1.286-.772C5.61 10.819 6.725 11.5 8 11.5s2.389-.681 3.002-1.699l1.286.772A4.996 4.996 0 018 13z"/>'
  }
})
